import { FunctionComponent, useState } from 'react'
import useStyles from './styles'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { ActionIcon, getTheme, Text } from '@conexasaude/conexa-hero'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { CareModals, CareTrackers } from '../../types'
import { RenderIf } from '@/components/RenderIf'
import { Icon } from '@conexasaude/iconography/icons'
import { useHistory } from 'react-router-dom'
import { CareFakedoorModal } from '../CareFakedoorModal'
import { CareCreateModalProps } from './types'
import { CareFakedoorActions } from '../CareFakedoorModal/CareFakedoorModal.types'

const CareCreateModal: FunctionComponent<CareCreateModalProps> = ({
  showOnlyAppointment,
}) => {
  const [fakedoorType, setFakedoorType] = useState<CareFakedoorActions>()
  const history = useHistory()
  const theme = getTheme()
  const styles = useStyles()
  const { showModal, closeModal } = useModalContext()
  const { logAnalyticsEvent } = useFirebaseContext()

  const scheduleAppointment = () => {
    logAnalyticsEvent(CareTrackers.AgendarConsulta)
    history.push('/atendimento-agendado/especialidades')
    closeModal()
  }

  const seeLater = () => {
    logAnalyticsEvent(CareTrackers.DeixarParaDepois)
    closeModal()
  }

  const openFakedoorModal = (type: CareFakedoorActions) => () => {
    setFakedoorType(type)
    trackFakedoorByType(type)
    showModal(CareModals.Fakedoor, {
      width: 480,
    })
  }

  const trackFakedoorByType = (type: CareFakedoorActions) => {
    switch (type) {
      case CareFakedoorActions.REGISTER_EXAM_OR_APPOINTMENT:
        logAnalyticsEvent(CareTrackers.RegistrarExame)
        break
      case CareFakedoorActions.CREATE_REMINDER:
        logAnalyticsEvent(CareTrackers.AdicionarLembrete)
        break
      default:
        break
    }
  }

  return (
    <>
      <Modal
        title="Novo cuidado"
        id={CareModals.Create}
        onDismiss={showOnlyAppointment && seeLater}
        size={480}
        trapFocus={false}
        primaryActionLabel={showOnlyAppointment ? 'Agendar consulta' : null}
        negativeActionLabel={showOnlyAppointment ? 'Deixar para depois' : null}
        primaryAction={scheduleAppointment}
        negativeAction={seeLater}
      >
        <RenderIf condition={showOnlyAppointment}>
          <div css={styles.modalWrapper}>
            <div css={styles.modalOnlyAppointment}>
              <Icon css={styles.modalIcon} name="calendar" size="large" />
              <div css={styles.gap}>
                <Text>
                  <b>Vamos começar?</b>
                </Text>
                <Text>
                  O primeiro passo para iniciar a sua jornada de cuidados é
                  agendar uma consulta.
                </Text>
              </div>
            </div>
          </div>
        </RenderIf>
        <RenderIf condition={!showOnlyAppointment}>
          <div>
            <Text css={styles.description}>
              Escolha abaixo como deseja cuidar da sua saúde.
              <br /> Algumas opções estarão disponíveis em breve.
            </Text>
            <div css={styles.cardsWrapper}>
              <div
                css={styles.centered}
                onClick={scheduleAppointment}
                role="button"
              >
                <ActionIcon
                  icon="doctor-talk"
                  size="3x-large"
                  variant="primary"
                />
                <Text
                  variant="paragraphSmall"
                  color={theme.colors.brand.primary[300]}
                  textAlign="center"
                >
                  Agendar consulta
                </Text>
              </div>
              <div
                css={styles.centered}
                onClick={openFakedoorModal(
                  CareFakedoorActions.REGISTER_EXAM_OR_APPOINTMENT,
                )}
                role="button"
              >
                <ActionIcon
                  icon="clipboard"
                  size="3x-large"
                  variant="primary"
                  tagProps={{
                    children: 'Em breve',
                    variant: 'primary',
                  }}
                />
                <Text
                  variant="paragraphSmall"
                  color={theme.colors.brand.primary[300]}
                  textAlign="center"
                >
                  Registrar exame
                  <br /> ou consulta
                </Text>
              </div>
              <div
                css={styles.centered}
                onClick={openFakedoorModal(CareFakedoorActions.CREATE_REMINDER)}
                role="button"
              >
                <ActionIcon
                  icon="calendar"
                  size="3x-large"
                  variant="primary"
                  tagProps={{
                    children: 'Em breve',
                    variant: 'primary',
                  }}
                />
                <Text
                  variant="paragraphSmall"
                  color={theme.colors.brand.primary[300]}
                  textAlign="center"
                >
                  Adicionar lembrete
                </Text>
              </div>
            </div>
          </div>
        </RenderIf>
      </Modal>
      <CareFakedoorModal type={fakedoorType}></CareFakedoorModal>
    </>
  )
}

export { CareCreateModal }
